var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: { id: "delete_client_modal" },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("deleteClientModal.title")))]),
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn",
                    on: {
                      click: function ($event) {
                        return _vm.closeDeleteClientModal()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-footer-buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "ml-4 bb-btn btn-secondary",
                    on: {
                      click: function ($event) {
                        return _vm.closeDeleteClientModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("deleteClientModal.cancelBtn")) + " "
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "ml-4 bb-btn btn-danger",
                    on: {
                      click: function ($event) {
                        return _vm.deleteClient()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("deleteClientModal.confirmBtn")) + " "
                    ),
                  ]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("p", { staticClass: "confirmation-message" }, [
        _vm._v(" " + _vm._s(_vm.confirmationMessage) + " "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }